export default __webpack_public_path__ + "static/media/logo_EnerTEF.f445653e.svg";